import { useQuery } from '@tanstack/react-query';
import { categoriasApi } from '@/lib/api';

export function useCategorias() {
  return useQuery({
    queryKey: ['categorias-publico'],
    queryFn: async () => {
      const response = await categoriasApi.listarPublico();
      const data = response.data;
      if (data && typeof data === 'object' && 'data' in data && Array.isArray(data.data)) {
        return data.data as any[];
      }
      return (Array.isArray(data) ? data : []) as any[];
    },
  });
}


export function useCategoria(id: string) {
  return useQuery({
    queryKey: ['categoria', id],
    queryFn: async () => {
      const response = await categoriasApi.buscar(id);
      const data = response.data;
      if (data && typeof data === 'object' && 'success' in data && data.data) {
        return data.data;
      }
      return data;
    },
    enabled: !!id,
  });
}

